/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_0b586dc7"]'><div :class='["toast-example-demo"]'><cube-button @_click="clickToast">Toast - 基本使用</cube-button><cube-toast txt="toast" ref="__mpx_ref_toast__"></cube-toast></div></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_0b586dc7"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_0b586dc7"}
  /** script content **/
  require("./toast-example.mpx.js?isComponent&outputPath=components%2Ftoast-example0b586dc7%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./toast-example.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftoast-example0b586dc7%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_0b586dc7"],
    ctorType: "component",
    outputPath: "components/toast-example0b586dc7/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>